module.exports = __webpack_public_path__ + "img/corp-zkhy_2x.cbaf705b.jpg";